<template>
  <div class="statistics">
      <div class="content"
        v-for="(item, $idx) in list"  :key="$idx">
        <div class="title">
            <span class="left">{{$idx + 1}}:  {{item.topicName}} </span>
            <span class="right">【{{typeMap(item.topicType)}}】</span>
        </div>
        <div class="avg" v-if="/^(rate|nps)$/.test(item.topicType)">
            本题平均分：{{item.avgScore}}
            <span v-if="item.topicType === 'nps'" class="nps-value">NPS值：{{item.nps}}</span>
        </div>
        <div class="table" v-if="/^(radio|checkbox|rate|nps)$/.test(item.topicType)">
            <CarTable
                :dataSource="sourceMap(item.answerList,item.total)"
                :columns="columnsA"
                >
            </CarTable>
        </div>
        <div class="table" v-if="/^textarea$/.test(item.topicType) ">
            <CarTable
                :dataSource="sourceMap(item.answerList,item.total)"
                :columns="columnsB"
                >
                <!-- <template v-slot:label1="{row}" v-if="item.topicType == 'textarea'">
                    <me-tag type="danger">{{row.label}}</me-tag>
                </template>
                <template v-slot:value1="{value}">
                    <div>{{value}}元</div>
                </template> -->
            </CarTable>
        </div>
        <div class="table" v-if="/^matrix-rate$/.test(item.topicType)">
            <CarTable
                :dataSource="sourceMapMatrix(item.answerList)"
                :columns="sourceMapColumn(item)"
                :topicType="item.topicType"
                >
            </CarTable>
        </div>
      </div>
  </div>
</template>
<script>
import { Questionnaire } from '@/network'
import { Toast } from '@guazi-fe/melon'

export default {
    name: 'statistics',
    data() {
        return {
            columnsA: [{
                title: '选项',
                key: 'label',
                dataIndex: 'label',
                formatterLineStyle: () => ({
                    background: '#F6F6F6',
                }),
            },
            {
                title: '小计',
                key: 'value1',
                dataIndex: 'value1',
                formatterLineStyle: () => ({
                    background: '#F6F6F6',
                }),
            },
            {
                title: '比例',
                key: 'value2',
                dataIndex: 'value2',
                formatterLineStyle: () => ({
                    background: '#F6F6F6',
                }),
            }],
            columnsB: [{
                title: '答题内容',
                key: 'label',
                dataIndex: 'label',
                formatterLineStyle: () => ({
                    background: '#F6F6F6',
                }),
            },
            {
                title: '小计',
                key: 'value1',
                dataIndex: 'value1',
                formatterLineStyle: () => ({
                    background: '#F6F6F6',
                }),
            },
            {
                title: '比例',
                key: 'value2',
                dataIndex: 'value2',
                formatterLineStyle: () => ({
                    background: '#F6F6F6',
                }),
            }],
            list: [],
        }
    },
    computed: {
        pageId() {
            return this.$route.params.pageId
        },
    },
    created() {
        this.getStatisticTopic()
    },
    methods: {
        getStatisticTopic() {
            Questionnaire.getStatisticTopic({
                tid: this.tid,
                pageId: this.$route.params.pageId,
            }).then((res) => {
                if (res.data.code == 'S00000') {
                    this.list = res.data.data
                    // this.list.shift()
                    // this.list.unshift(list)
                    this.list.forEach((item) => {
                        item.answerList && item.answerList.forEach((answerList, index) => {
                            if (item.topicType === 'matrix-rate') {
                                // 将answerCount转换为{valueX: 值}对象
                                const answerCount = answerList.answerCount && answerList.answerCount.split('┇') || []
                                let i = 1
                                answerCount.forEach((key) => {
                                    answerList[`value${i++}`] = key
                                })
                                // 将最后一行加title: 小计
                                if (item.answerList.length - 1 === index) {
                                    answerList.title = answerList.answerValue
                                }
                            }
                        })
                    })
                    console.log(111, this.list)
                    // this.list.pop()
                    // console.log(this.list)
                }
            }).catch((error) => {
                console.log(error.response)
                Toast.fail(error.response.data.message)
            })
        },
        typeMap(type) {
            const list = {
                'radio': '单选题',
                'checkbox': '多选题',
                'textarea': '填空',
                'paragraph': '备注说明',
                'rate': '评分题',
                'nps': 'NPS题',
                'matrix-rate': '矩阵评分'
            }
            return list[type]
        },
        buildAnswerRow(item, options = {}) {
            const prefix = options.prefix || ''
            return {
                label: `${prefix}${item.answerValue}`,
                value1: item.answerCount,
                value2: item.answerPercent,
                formatterLineStyle: options.formatterLineStyle,
                formatterValueStyle: options.formatterValueStyle,
            }
        },
        sourceMap(answerList = [], total) {
            const childLineStyle = () => ({
                background: '#FBFBFB',
                paddingLeft: '120px',
            })
            const childValueStyle = () => ({
                color: '#5F6670',
                paddingLeft: '12px',
            })
            const list = []
            answerList.forEach((item) => {
                list.push(this.buildAnswerRow(item))
                if (Array.isArray(item.subAnswerList) && item.subAnswerList.length) {
                    item.subAnswerList.forEach((subItem) => {
                        list.push(this.buildAnswerRow(subItem, {
                            prefix: '└─ ',
                            formatterLineStyle: childLineStyle,
                            formatterValueStyle: childValueStyle,
                        }))
                    })
                }
            })
            list.push({
                label: '本题有效填写次数',
                value1: total,
                formatterLineStyle: () => ({
                    background: '#F6F6F6',
                }),
            })
            return list
        },
        // 取第一行数据所有的key做column的值
        sourceMapColumn(item) {
            let { answerList, selectItem } = item
            // 找到第一个有 value1 字段的数据行（跳过只有 title 的行）
            const firstDataRow = answerList.find(row => row.value1 !== undefined)
            let cols = firstDataRow ? Object.keys(firstDataRow) : []
            // 过滤掉不需要的字段，只保留 value1, value2, ... 这些列
            cols = cols.filter(item => /^value\d+$/.test(item))
            // 按 value1, value2, ... 的顺序排序
            cols.sort((a, b) => {
                const numA = parseInt(a.replace('value', ''), 10)
                const numB = parseInt(b.replace('value', ''), 10)
                return numA - numB
            })
            // 用 selectItem 来设置表头的 title
            let list = cols.map((item, i) => ({
                title: selectItem[i] ? selectItem[i].itemKey : '',
                key: item,
                dataIndex: item,
                formatterLineStyle: () => ({
                    background: '#F6F6F6',
                }),
            }))
            // 在开头添加 title 列（第一列）
            list.unshift({
                title: '',
                key: 'title',
                dataIndex: 'title',
                formatterLineStyle: () => ({
                    background: '#F6F6F6',
                }),
            })
            // 在末尾添加平均分列
            list.push({
                title: '平均分',
                key: 'answerPercent',
                dataIndex: 'answerPercent',
                formatterLineStyle: () => ({
                    background: '#F6F6F6',
                }),
            })
            return list
        },
        sourceMapMatrix(answerList) {
            const newAnswerList = JSON.parse(JSON.stringify(answerList))
            // 找到第一个有 value1 字段的数据行，获取所有 value 列的 key
            const firstDataRow = newAnswerList.find(row => row.value1 !== undefined)
            if (!firstDataRow) {
                return newAnswerList
            }
            // 获取所有 value 列的 key（value1, value2, ...）
            const valueKeys = Object.keys(firstDataRow).filter(key => /^value\d+$/.test(key))
                .sort((a, b) => {
                    const numA = parseInt(a.replace('value', ''), 10)
                    const numB = parseInt(b.replace('value', ''), 10)
                    return numA - numB
                })
            // 创建一个包含所有 value 字段的空对象（用于 title 行）
            const emptyValueObj = {}
            valueKeys.forEach(key => {
                emptyValueObj[key] = ''
            })
            // 构建新的数组，在每个数据行前面插入一个 title 行
            const result = []
            newAnswerList.forEach((item) => {
                // 只处理有 value1 字段的数据行（跳过"小计"行，因为它可能没有 value1 或者 title 字段）
                if (item.value1 !== undefined && !item.title) {
                    // 先插入 title 行
                    result.push({
                        title: item.answerValue,
                        topicType: 'matrix-rate',
                        answerPercent: '', // 平均分列也设为空
                        ...emptyValueObj, // 包含所有 value 字段，值为空
                    })
                    // 再插入数据行
                    result.push(item)
                } else {
                    // 其他行（如"小计"行）直接添加
                    result.push(item)
                }
            })
            return result
        }
    },
}
</script>
<style lang="scss" scoped>
    .statistics{
        padding: 12px 20px;
        background: #fff;
    }
    .content{
        margin-bottom: 20px;
    }
    .title{
        font-size: 14px;
        margin-bottom: 15px;
        .left{
            font-weight: bold;
            color: #222222;
        }
        .right{
            color: #9298A8
        }
    }
    .avg{
        margin-bottom: .4rem;
    }
    .nps-value{
        margin-left: 1rem;
    }
    ::v-deep .table .car-table{
        width: 100%;
        color: #5F6670;
        thead  {
            height: 28px;
            background: #F6F6F6;
            padding: 0 6px;
            line-height: 0;
        }
        th,td{
            height: 28px;
            word-wrap: break-word !important;
            word-break:break-all !important;
            padding: 2px 6px;
            &:last-child{
                width: 60px;
            }
            &:nth-last-child(2){
                width: 80px;
            }
        }
        tr{
            line-height: 0;
            padding: 0 6px;
            &:last-child{
                height: 28px;
                background: #F6F6F6;
            }
        }
    }
</style>
